import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=602831d0&scoped=true&"
import script from "./GlobalMenu.vue?vue&type=script&lang=ts&"
export * from "./GlobalMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&id=602831d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602831d0",
  null
  
)

export default component.exports